//Payment successfull page

import { useEffect, useState } from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { ThemeProvider } from '@mui/material/styles';
import getTheme from '../../theme/theme';
import axios from 'axios';
import { Link,useNavigate } from 'react-router-dom';
import { OrganizationFinal } from './Subscription';
import { BASEURL, ARROW } from '../../constants/Common';
import FloatingButton from '../usersupport/helpdesk/FloatingButton';

const PaymentSuccessfulpage: React.FC = () => {
  const navigate = useNavigate();
  const [organizationfinal, setOrganizationFinal] =
    useState<OrganizationFinal | null>(null);

  const orgData = localStorage.getItem('orgid');
  let parsedData: any; // Define parsedData variable with 'any' type

  if (orgData) {
    parsedData = JSON.parse(orgData);
  } else {
    navigate('/login')
  }

  const organizationid = orgData;

  //fetch organization details using organization id
  useEffect(() => {
    const fetchOrganization = async () => {
      try {
        const response = await axios.get(
          BASEURL + '/organization' + `/${organizationid}/`,
          {
            headers: {
              Accept: 'application/json',
            },
          }
        );

        setOrganizationFinal(response.data);
        const subscriptionStatus = response.data.organization?.organization_subscription_status;
        localStorage.setItem('subscriptionstatus', subscriptionStatus)
      } catch (error) {
        console.log(error);
      }
    };
    fetchOrganization();
  }, []);

  return (
    <div>
      <ThemeProvider theme={getTheme()}>
        <Box>
          <Typography variant='h6' gutterBottom sx={{ mt: '-60px' }}>
            <Link to={'/subscriptions'}>Subscriptions</Link> {ARROW} Payment
          </Typography>

          <Grid container spacing={2} sx={{ mt: '10%' }}>
            <Grid item xs={8} sx={{ ml: '100px', mt: '-38px' }}>
              <h3>Payment Successful</h3>

              <h4>
                Your Payment for {organizationfinal?.subscription_plan?.title}{' '}
                plan is completed
              </h4>
              {/* <Grid container spacing={2}>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>Amount Paid:</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Typography variant='subtitle1'>
                    USD {organizationfinal?.subscription_plan?.price}
                  </Typography>
                </Grid>
                <Grid item xs={6} sx={{ mt: '10px' }}>
                  <Typography variant='subtitle1'>Duration:</Typography>
                </Grid>
                <Grid item xs={6} sx={{ mt: '10px' }}>
                  <Typography variant='subtitle1'>1 year</Typography>
                </Grid>
              </Grid> */}
            </Grid>
          </Grid>
          <FloatingButton/>
        </Box>
      </ThemeProvider>
    </div>
  );
};

export default PaymentSuccessfulpage;
